// Navigation
export const ROUTES = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  DEVICE_LINK: "/device-link",
  DEVICE_STATUS: "/device-status",
  LOCATION_HISTORY: "/location-history",
  PARKING_HISTORY: "/parking-history",
  PARKING_LOCATIONS: "/parking-locations",
  USER_SETTINGS: "/user-settings",
} as const;

// UI Constants
export const THEME_MODES = {
  LIGHT: "light",
  DARK: "dark",
  SYSTEM: "system",
} as const;

export const LANGUAGES = {
  EN: "en",
  PL: "pl",
} as const;

// Device Constants
export const DEVICE_STATUS = {
  ONLINE: "online",
  OFFLINE: "offline",
  CONNECTING: "connecting",
  ERROR: "error",
} as const;

// Parking Constants
export const PARKING_STATUS = {
  ACTIVE: "active",
  STOPPED: "stopped",
  PENDING: "pending",
} as const;

// Trip Constants
export const TRIP_STATUS = {
  ACTIVE: "active",
  COMPLETED: "completed",
  PAUSED: "paused",
} as const;

// Location Constants
export const DEFAULT_MAP_ZOOM = 15;
export const DEFAULT_LOCATION_RANGE = 100; // meters

// Map Configuration
export const MAP_LOCATIONS = {
  WARSAW: {
    name: "Warsaw",
    coordinates: { lat: 52.22891891946285, lng: 21.0115514481553 },
  },
  HOME: {
    name: "Home - Włodarzewska 57B",
    address: "Włodarzewska 57B, 02-384 Warsaw",
    coordinates: { lat: 52.201130962894865, lng: 20.956020620765695 },
  },
  WORK: {
    name: "Work - Aleje Jerozolimskie 181B",
    address: "Aleje Jerozolimskie 181B",
    coordinates: { lat: 52.21036088270734, lng: 20.952744748123262 },
  },
} as const;

// Validation Constants
export const VALIDATION = {
  MIN_DEVICE_CODE_LENGTH: 6,
  MAX_DEVICE_CODE_LENGTH: 12,
  MIN_LOCATION_NAME_LENGTH: 1,
  MAX_LOCATION_NAME_LENGTH: 50,
  MIN_RANGE: 10,
  MAX_RANGE: 1000,
} as const;

// Storage Keys
export const STORAGE_KEYS = {
  THEME: "gpsbox-theme",
  LANGUAGE: "gpsbox-language",
  SIDEBAR_STATE: "gpsbox-sidebar-state",
} as const;
